import { InfiniteData } from "@tanstack/react-query";

import { GetAccountUsersQuery } from "@/api/graphql/types/graphql.ts";

import { FeAccountUsersDetail } from "./types";

export const toAccountUsersBO = (
  queryResponse: InfiniteData<GetAccountUsersQuery | undefined>,
): Array<FeAccountUsersDetail> => {
  if (queryResponse) {
    return queryResponse.pages.reduce<Array<FeAccountUsersDetail>>(
      (acc, page) => {
        const searchUsersOnCurrentPage =
          page?.AccountsMsSearchPrivileges.data &&
          page?.AccountsMsSearchPrivileges.data.length > 0
            ? page.AccountsMsSearchPrivileges.data.map<FeAccountUsersDetail>(
                (accountUser) => ({
                  id: accountUser.id,
                  lastUsedTs: accountUser.lastUsedTs,
                  status: accountUser.status,
                  userId: accountUser.UserIdData?.id || "",
                  userFirstName: accountUser.UserIdData?.firstName || "",
                  userLastName: accountUser.UserIdData?.lastName || "",
                  userEmail: accountUser.UserIdData?.email || "",
                  userCreatedTs: accountUser.UserIdData?.createdTs || 0,
                  subscription: {
                    roleName:
                      accountUser?.Subscriptions?.[0]?.RolesProfileIdData
                        ?.name || "",
                    roleCode:
                      accountUser?.Subscriptions?.[0]?.RolesProfileIdData
                        ?.code || "",
                  },
                }),
              )
            : [];

        if (searchUsersOnCurrentPage.length > 0) {
          acc.push(...searchUsersOnCurrentPage);
        }

        return acc;
      },
      [],
    );
  }

  return [];
};
